import Rollbar from 'rollbar';

import profileService from '@d-services/profile-service/profile-service';

import ignoreLocalStorage from './ignore-modules/local-storage';
import ignoreTimeout from './ignore-modules/timeout';

class RollbarLogger {
  constructor() {
    /* istanbul ignore next */
    if (!process.env.ROLLBAR_CLIENT_TOKEN) {
      return;
    }

    /* istanbul ignore next */
    this.initRollbar();
  }

  /* istanbul ignore next */
  async initRollbar() {
    const userId = await profileService.getUserId();

    this._rollbar = new Rollbar({
      accessToken: process.env.ROLLBAR_CLIENT_TOKEN,
      // TODO: re-enable once Google One Tap issues are sorted
      captureUncaught: false,
      captureUnhandledRejections: false,
      hostSafeList: [ 'reedsy.com' ],
      payload: {
        environment: process.env.RAILS_ENV,
        person: {
          id: userId,
        },
      },
      checkIgnore: function(isUncaught, args, payload) {
        let shouldIgnore = false;

        const firstArg = args[0];
        shouldIgnore = ignoreTimeout(firstArg) || ignoreLocalStorage(firstArg);

        return shouldIgnore;
      },
    });
  }

  /* istanbul ignore next */
  error(err) {
    if (!this._rollbar) {
      return;
    }

    this._rollbar.error(err);
  }
}

export default new RollbarLogger();
